import React from "react";
import LegalPageLayout from "../components/LegalPageLayout";

export default function DataDeletionPolicyPage() {
  return (
    <LegalPageLayout title="Data Deletion Policy" lastUpdated="1st Jan 2026">
      <p>We respect users’ right to delete their data.</p>

      <section>
        <h2 className="text-xl font-bold text-slate-900">
          1. How to Request Data Deletion
        </h2>
        <p className="mt-2">
          If you want to delete your data from the service, please send an email to:
        </p>
        <p className="mt-2">
          <a
            href="mailto:prakharpandedevwork@gmail.com"
            className="text-blue-600 hover:text-blue-700 font-semibold"
          >
            prakharpandedevwork@gmail.com
          </a>
        </p>
        <p className="mt-4">Include:</p>
        <ul className="mt-2 list-disc pl-6">
          <li>Your WhatsApp phone number</li>
          <li>A clear request for data deletion</li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-bold text-slate-900">2. What Data Is Deleted</h2>
        <p className="mt-2">Upon request, we will delete:</p>
        <ul className="mt-2 list-disc pl-6">
          <li>Your phone number</li>
          <li>All reminders associated with your account</li>
          <li>Any related usage data</li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-bold text-slate-900">3. Processing Time</h2>
        <p className="mt-2">
          Data deletion requests are typically processed within 7–14 business
          days.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-slate-900">4. Confirmation</h2>
        <p className="mt-2">
          Once your data is deleted, you will receive a confirmation email.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-slate-900">5. Exceptions</h2>
        <p className="mt-2">
          We may retain minimal data if required to comply with legal
          obligations.
        </p>
      </section>
    </LegalPageLayout>
  );
}


